var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 6",
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.54,51H17.22a4.64,4.64,0,0,1-4.63-4.62V17.28a4.64,4.64,0,0,1,4.63-4.63H45.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.43,17.28V46.36A4.64,4.64,0,0,1,45.8,51h-9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.48,
    cy: 13.95,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.54,51V38.51h-4.4V32.57h4.4V26.84a6,6,0,0,1,6-6h6.23v5.65H38.21A1.47,1.47,0,0,0,36.74,28v4.54h6v6h-6V51"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.dfaed2605eb3b09630ca680e8304c261.svg";
export { ForwardRef as ReactComponent };